import _toConsumableArray from "/home/batman/cabana/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/home/batman/cabana/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/batman/cabana/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/batman/cabana/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/batman/cabana/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/batman/cabana/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import { extractTransformsFromEncoding } from './encoding';
import { SpecMapper } from './spec/map';

var TransformExtractMapper =
/*#__PURE__*/
function (_SpecMapper) {
  _inherits(TransformExtractMapper, _SpecMapper);

  function TransformExtractMapper() {
    _classCallCheck(this, TransformExtractMapper);

    return _possibleConstructorReturn(this, _getPrototypeOf(TransformExtractMapper).apply(this, arguments));
  }

  _createClass(TransformExtractMapper, [{
    key: "mapUnit",
    value: function mapUnit(spec, _ref) {
      var config = _ref.config;

      if (spec.encoding) {
        var oldEncoding = spec.encoding,
            oldTransforms = spec.transform;

        var _extractTransformsFro = extractTransformsFromEncoding(oldEncoding, config),
            bins = _extractTransformsFro.bins,
            timeUnits = _extractTransformsFro.timeUnits,
            aggregate = _extractTransformsFro.aggregate,
            groupby = _extractTransformsFro.groupby,
            encoding = _extractTransformsFro.encoding;

        var transform = [].concat(_toConsumableArray(oldTransforms ? oldTransforms : []), _toConsumableArray(bins), _toConsumableArray(timeUnits), _toConsumableArray(!aggregate.length ? [] : [{
          aggregate: aggregate,
          groupby: groupby
        }]));
        return Object.assign({}, spec, transform.length > 0 ? {
          transform: transform
        } : {}, {
          encoding: encoding
        });
      } else {
        return spec;
      }
    }
  }]);

  return TransformExtractMapper;
}(SpecMapper);

var extractor = new TransformExtractMapper();
/**
 * Modifies spec extracting transformations from encoding and moving them to the transforms array
 */

export function extractTransforms(spec, config) {
  return extractor.map(spec, {
    config: config
  });
}